<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/doo-finder/shared/doo-finder-search/doo-finder-search.component.ts
-->
<ng-template #anchor />
